import { render, staticRenderFns } from "./productType__list.vue?vue&type=template&id=7bb22e6a"
import script from "./productType__list.vue?vue&type=script&lang=js"
export * from "./productType__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports